import { Lightbulb } from '@phosphor-icons/react';

export default Lightbulb;
